import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { OtherUseService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  OtherUseCreateDto,
  OtherUseDto,
  OtherUseExcelDownloadDto,
  OtherUseUpdateDto,
} from '../proxy/planning/dtos/other-use';
import { OTHERUSE_CONFIG, OTHERUSE_FIELDS } from './other-use.config';
import { BaseHierarchicalCrudComponent, FieldMapperHelper, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';
import { OtherUseOrchestratorService } from 'projects/orchestrator/src/lib/proxy/orchestrator/app-services/other-use-orchestrator.service';
import { OtherUseCreateWithLocationDto } from 'projects/orchestrator/src/lib/proxy/orchestrator/dtos/other-use/models';

@Component({
  selector: 'app-other-use',
  imports: [
    CommonModule,
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, OtherUseService, ConfirmationService],
  templateUrl: './other-use.html',
  styleUrl: './other-use.scss',
})
export class OtherUse extends BaseHierarchicalCrudComponent<
  OtherUseDto,
  OtherUseCreateDto | OtherUseCreateWithLocationDto,
  OtherUseUpdateDto,
  OtherUseExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  private readonly crudService = inject(OtherUseService);
  private readonly orchestratorService = inject(OtherUseOrchestratorService);
  service = {
    ...this.crudService,
    create: (input: OtherUseCreateDto | OtherUseCreateWithLocationDto) => 'locationId' in input
      ? this.crudService.create(input)
      : this.orchestratorService.createWithLocation(input),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('OtherUse', ids),
  };
  config = OTHERUSE_CONFIG;
  fields = OTHERUSE_FIELDS;

  override create(): void {
    if (this.parentId !== undefined && this.parentFilterField === 'locationId') {
      super.create();
      return;
    }

    this.selectedEntity = {} as OtherUseDto;
    const fields = FieldMapperHelper.mapFieldsForForm(
      this.fields.filter(field => field.key !== 'locationId'),
      this.selectedEntity,
      this.injector,
    );
    this.genericForm.open({
      title: `${this.localizationResource.LanguageService}::TableNewRegistry`,
      fields,
      entityLocaleKey: this.config.localizationKey,
    });
  }

  protected prepareUpdateDto(data: any, selected: OtherUseDto): OtherUseUpdateDto {
    return {
      name: data.name,
      otherUsearea: data.otherUsearea,
      soilUseId: data.soilUseId,
      locationId: data.locationId,
      propertyId: data.propertyId,
      propertyTypeId: data.propertyTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'OtherUse';
  }
}
